import { useState } from "react";
import { useParams } from "react-router";
import { EventCreateMentions } from "../../../../../../common/sesh_types";
import { DashboardUtils } from "../../../dashboard_utils";
import { SeshPrimaryButton } from "../base_components/sesh_primary_button";
import { useGuildMemberQuery } from "../hooks/use_guild_members";
import { useRoles } from "../hooks/use_roles";
import { MentionsSection } from "./server_reminders_mentions";

export function RoleMention(props: { id: string }) {
	const roles = useRoles();
	const role = roles.find((role) => role.id === props.id);

	return (
		<div className="flex-nowrap whitespace-nowrap rounded-md bg-discord-blurple bg-opacity-25 px-1">
			{role?.name
				? `${role.is_everyone_or_here ? "" : "@"}${role.name}`
				: "unknown"}
		</div>
	);
}

export function UserMention(props: { id: string }) {
	const { server_id } = useParams<{
		server_id: string;
	}>();
	const members_query = useGuildMemberQuery(server_id, [props.id]);

	const name = members_query.members?.[0]?.name;

	return (
		<div className="flex-nowrap whitespace-nowrap rounded-md bg-discord-blurple bg-opacity-25 px-1">
			{name ? `@${name}` : "unknown"}
		</div>
	);
}

export function ActiveMentionsModal(props: {
	header: string;
	user_mention_ids: string[];
	role_mention_ids: string[];
	onClose: () => void;
	onSubmit: (
		user_mention_ids: string[],
		role_mention_ids: string[],
		is_mirroring: boolean
	) => void;

	is_mirroring_mentions: boolean;
}) {
	const [ephemeral_user_mention_ids, setEphemeralUserMentionIds] = useState(
		props.user_mention_ids
	);
	const [ephemeral_role_mention_ids, setEphemeralRoleMentionIds] = useState(
		props.role_mention_ids
	);

	const [ephemeral_is_mirroring, setEphemeralIsMirroring] = useState(
		props.is_mirroring_mentions
	);

	return (
		<DashboardUtils.SeshModal
			is_active
			allow_overflow
			title={props.header}
			content={
				<div className="mt-2 flex flex-col gap-2">
					<MentionsSection
						member_ids={ephemeral_user_mention_ids}
						role_ids={ephemeral_role_mention_ids}
						onMembersChange={setEphemeralUserMentionIds}
						onRolesChange={setEphemeralRoleMentionIds}
						is_editing={true}
					/>
					<div
						className="ml-auto flex cursor-pointer items-center gap-2"
						onClick={() => {
							setEphemeralIsMirroring(!ephemeral_is_mirroring);
						}}
					>
						<input
							type="checkbox"
							checked={ephemeral_is_mirroring}
							readOnly
						/>{" "}
						Copy mentions to all notifications
					</div>
					<div className="ml-auto mt-2 flex w-fit">
						<SeshPrimaryButton
							onClick={() => {
								props.onSubmit(
									ephemeral_user_mention_ids,
									ephemeral_role_mention_ids,
									ephemeral_is_mirroring
								);
							}}
						>
							Set
						</SeshPrimaryButton>
					</div>
				</div>
			}
			onClose={props.onClose}
		/>
	);
}
